import React, { useState, useEffect } from "react";
import { withRedux } from "helpers";
import { DragDropContext } from "react-beautiful-dnd";
import Column from "./Column";

function TemplateOrdering({
  navigation,
  actions: { updateApplication },
  activeApp: { view },
  activeApp,
}) {
  // console.log("printing activeApp");
  // console.log(activeApp);
  const displayOrders = [];
  // go through all navigation components and add their title to array based on order recieved
  navigation.map((nav) => {
    // console.log(nav.order);
    return (displayOrders[nav.order - 1] = nav.title.text);
  });

  // console.log(navigation);
  const [templates, setTemplates] = useState({});
  const [column, setColumn] = useState({
    id: "column",
    title: "Reorder Pages",
    rowItemIds: [], // hold all items
  });

  useEffect(() => {
    const navigationMap = {}; // create a hashmap
    const rowItemIds = [...navigation] // go through all navigation components
      .sort((a, b) => a.order - b.order) // sort all navigation components
      .map((n) => n.templateId); // return a new array with ids only
    // console.log(rowItemIds);
    navigation.forEach((nav) => {
      // for each navigation component
      navigationMap[nav.templateId] = {
        // set key to the id, and value to an object that has id and title
        id: nav.templateId,
        content: nav.title.text,
      };
    });

    // console.log(navigationMap);
    // update columns and rows
    setColumn({
      ...column,
      rowItemIds,
    });
    // update templates object
    setTemplates(navigationMap);
  }, navigation);

  // drag drop logic
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.droppableId === source.draggableId ||
      destination.index === source.index
    )
      return;

    const newRowItemIds = [...column.rowItemIds];
    newRowItemIds.splice(source.index, 1);
    newRowItemIds.splice(destination.index, 0, draggableId);

    const newColumn = {
      ...column,
      rowItemIds: newRowItemIds,
    };

    setColumn(newColumn);
    // console.log(column);
    const newNavigation = navigation.map((nav) => {
      const order = newRowItemIds.indexOf(nav.templateId) + 1;
      return {
        ...nav,
        order,
      };
    });
    const newView = {
      ...view,
    };
    newView.navigation.components = newNavigation;
    updateApplication("view", newView);
  };

  const rowItems = column.rowItemIds.map((id) => templates[id]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Column key={column.id} column={column} rowItems={rowItems} />
    </DragDropContext>
  );
}

export default withRedux(TemplateOrdering);
